import { Injectable } from "@angular/core";

import { UserSessionService } from "../../../services/user-session/user-session.service";
import { WebservicesService } from "../../../services/webservices/webservices.service";
import { ConfigService } from "../../../services/config/config.service";
import { CustomerModel } from "../../../models/customer-model";
import { InAppBrowserObject } from "@ionic-native/in-app-browser/ngx";
import {
  GameLaunchParams,
  VendorAdapterInterface,
} from "./vendor-adapter-interface";
import {
  PalaOGSLauncherInterface,
  GameViewInterface,
  ODRController,
} from "../../odr-controller";
import { Subject } from "rxjs";
import { AlertController } from "@ionic/angular";
import { PlatformResponse } from "src/app/interfaces/webservices-interface";

declare var palaOGSLauncher: PalaOGSLauncherInterface;

export interface GameRequest {
  name: string;
  gameId: number;
  addressIp: any;
  port: number;
  chipType: string;
  gameTypeId: number;
  numSeats?: number;
  sessionId: any;
}

class OGSGameView implements GameViewInterface {
  public closed: boolean = false;

  constructor(alert: any) {
    // alert.present();
    // setTimeout(() => {
    //   if (alert) {
    //     alert.dismiss();
    //     alert = null;
    //   }
    // }, 15 * 1000);
    setTimeout(() => {
      var id = setInterval(() => {
        palaOGSLauncher.isGameClosed(
          [],
          (isclosed: boolean) => {
            this.closed = isclosed;
            if (isclosed) {
              // if (alert) {
              //   alert.dismiss();
              // }
              clearInterval(id);
            }
          },
          (err: any) => {
            // no errors, thx!
          }
        );
      }, 50);
    }, 500);
  }

  close(): void {
    palaOGSLauncher.close(
      null,
      (success) => {},
      (err) => {}
    );
  }
}

@Injectable()
export class NYXAdapter implements VendorAdapterInterface {
  protected customer: CustomerModel;
  protected sessionToken: string;
  protected windowRef: GameViewInterface;

  constructor(
    private webservices: WebservicesService,
    private userSession: UserSessionService,
    private config: ConfigService,
    private telemetrySubject: Subject<any>
  ) {
    this.userSession.getCustomer().subscribe((customer) => {
      this.customer = customer;
      this.sessionToken = this.userSession.getSessionToken();
    });
  }

  public setWindowRef(windowRef: InAppBrowserObject | GameViewInterface): void {
    this.windowRef = windowRef as GameViewInterface;
  }

  public getWindowRef(): InAppBrowserObject | GameViewInterface {
    return this.windowRef;
  }

  public odrSessionId(): Subject<any> {
    return this.telemetrySubject;
  }

  public windowStrategy() {
    return "launchOGS";
  }

  public shouldDescendIntoDirs() {
    return false;
  }

  public getTagLayout(extGameParams: GameLaunchParams): Promise<Array<any>> {
    return this.config.isLoaded().then(() => {
      let jurisdiction = ODRController.clientAppJurisdiction(
        this.config.getClientApp()
      );
      let tag = `${extGameParams.vendor}-${jurisdiction}-${extGameParams.extGameType}`;
      console.log("ODR: tag == " + tag);
      return [{ loc: "/", tag: tag }];
    });
  }

  public credentials(p: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.webservices
        .get("games/get-vendor-credentials", {
          customer_id: p.customer_id ? p.customer_id : null,
          session_token: p.session_token ? p.session_token : null,
          vendor: "nyx",
          game_launcher_id: p.gameLaunchId,
          clientapp: this.config.getClientApp(),
        })
        .subscribe(
          (resp: PlatformResponse<any>) => {
            this.telemetrySubject.next(resp.payload.sessionid);
            resolve(Object.assign(p, resp.payload));
          },
          (err: any) => {
            console.log("slingo: games/get-vendor-credentials error: ", err);
            reject(err);
          }
        );
    });
  }

  public launchOGS(alertCtrl: AlertController, $gamePrms: Promise<any>) {
    $gamePrms.then((gamePrms) => {
      var jurisdiction;
      if (gamePrms.ODR && gamePrms.ODR.extra_launch_data) {
        if ("string" === typeof gamePrms.ODR.extra_launch_data) {
          gamePrms.ODR.extra_launch_data = JSON.parse(
            gamePrms.ODR.extra_launch_data
          );
        }
        if (gamePrms.ODR.extra_launch_data.jurisdiction) {
          jurisdiction = gamePrms.ODR.extra_launch_data.jurisdiction;
        }
      }

      var options = {
        domain: this.config.getConfig().FEATURE_NYX_DOMAIN,
        gameId: gamePrms.nogsgameid,
        accountId: gamePrms.accountid,
        currency: gamePrms.nogscurrency || "USD",
        mode: gamePrms.nogsmode,
        operatorId: gamePrms.nogsoperatorid,
        language: gamePrms.nogslang,
        sessionId: gamePrms.sessionid,
        // lobbyUrl: gamePrms.lobbyurl,
        lobbyUrl: "http://localhost:9090/close",
        device: "mobile",
        jurisdiction: jurisdiction,
      };
      palaOGSLauncher.launchOGS(
        options,
        (value) => {
          console.log(
            "ODR: palaOGSLauncher.launchOGS( " +
              JSON.stringify(options) +
              ") ->",
            value
          );
        },
        (err) => {
          console.log("ODR: error:", err);
        }
      );
    });

    var alert: any = alertCtrl.create({
      message: "Loading Game",
    });
    var windowRef = new OGSGameView(alert);
    this.setWindowRef(windowRef);
    return windowRef;
  }

  public evaluateJavascript(js: string): Promise<any> {
    return new Promise((resolve: any, reject) => {
      palaOGSLauncher.OGSEvaluateJavascript(js, resolve, reject);
    });
  }

  public onGameClosed(windowRef: GameViewInterface, closedCb: () => void) {
    console.log("ODR: nyx.ts: onGameClosed");
    var ticket: number = 1; // prevent closeCb from being called by multiple close events

    let intervalID = setInterval(() => {
      if (windowRef.closed) {
        clearInterval(intervalID);
        closedCb();
      }
    }, 500);
  }
}
